module.exports = {
  "zones": {
    "Africa/Cairo": ["z", {
      "wallclock": -2185401600000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": -2185409109000,
      "save": 0,
      "rules": "Egypt"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 7509000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Egypt": [{
      "from": 2014,
      "to": 2014,
      "month": 4,
      "day": [7, 15],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 2014,
      "to": 2014,
      "month": 5,
      "day": [7, 26],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2014,
      "to": 2014,
      "month": 6,
      "day": [7, 31],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 2014,
      "to": 2014,
      "month": 8,
      "day": [4, -30],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1995,
      "to": 2010,
      "month": 3,
      "day": [5, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 2010,
      "to": 2010,
      "month": 7,
      "day": [7, 10],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2010,
      "to": 2010,
      "month": 8,
      "day": [7, 9],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 2010,
      "to": 2010,
      "month": 8,
      "day": [4, -30],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2009,
      "to": 2009,
      "month": 7,
      "day": [7, 20],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2008,
      "to": 2008,
      "month": 7,
      "day": [4, -31],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2007,
      "to": 2007,
      "month": 8,
      "day": [4, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2006,
      "to": 2006,
      "month": 8,
      "day": [7, 21],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1995,
      "to": 2005,
      "month": 8,
      "day": [4, -30],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1966,
      "to": 1994,
      "month": 9,
      "day": [7, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1990,
      "to": 1994,
      "month": 4,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1989,
      "to": 1989,
      "month": 4,
      "day": [7, 6],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1984,
      "to": 1988,
      "month": 4,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1983,
      "to": 1983,
      "month": 6,
      "day": [7, 12],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1982,
      "to": 1982,
      "month": 6,
      "day": [7, 25],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1959,
      "to": 1981,
      "month": 4,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1959,
      "to": 1965,
      "month": 8,
      "day": [7, 30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1957,
      "to": 1958,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1958,
      "to": 1958,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1957,
      "to": 1957,
      "month": 4,
      "day": [7, 10],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1945,
      "month": 10,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 3,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1944,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1942,
      "month": 9,
      "day": [7, 27],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1941,
      "to": 1941,
      "month": 3,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1941,
      "month": 8,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 6,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1940,
      "to": 1940,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};